import Actions from '../Collection/actions'

const actions = Actions.get('SHOP_');

export default actions;
